import React from 'react';
import {NavLink} from "react-router-dom";
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import {createStyles, makeStyles} from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import Home from "@material-ui/icons/Home";
import Person from "@material-ui/icons/Person";
import Reply from "@material-ui/icons/Reply";
import LibraryBooks from "@material-ui/icons/LibraryBooks";
import Link from '@material-ui/core/Link';
import Collapse from '@material-ui/core/Collapse';
import StarBorder from '@material-ui/icons/StarBorder';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import CallSplitIcon from '@material-ui/icons/CallSplit';
import SettingsIcon from '@material-ui/icons/Settings';
import {pages as pagesLang} from '@language/index';
import FormatListNumberedIcon from '@material-ui/icons/FormatListNumbered';
import {useTranslation} from "react-i18next";

const useStyles = makeStyles((theme) =>
    createStyles({
        mainMenuList: {
            padding: '0',
        },
        mainMenuItem: {
            color: '#fff',
            '&.active': {
                color: '#4fc3f7',
            },
            fontSize: '14px',
        },
        mainMenuItemHome: {
            backgroundColor: '#232f3e',
        },
        mainMenuIcon: {
            color: 'inherit',
            minWidth: '30px',
        },
        divider: {
            backgroundColor: '#404854',
        },
        nested: {
            paddingLeft: theme.spacing(6),
        },
    }),
);

const MainMenu = (props) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const [open, setOpen] = React.useState(true);
    const handleClick = () => {
        setOpen(!open);
    };
    const {digitalProfileSettings} = props;
    return (
            <List className={classes.mainMenuList}>
                <ListItem
                    className={`${classes.mainMenuItem} ${classes.mainMenuItemHome}`}
                    button
                    component={NavLink}
                    exact
                    to="/">
                    <ListItemIcon className={classes.mainMenuIcon}>
                        <Home />
                    </ListItemIcon>
                    <ListItemText primary={t('home')} />
                </ListItem>
                <Divider className={classes.divider} />
                <ListItem className={classes.mainMenuItem} button onClick={handleClick}>
                    <ListItemIcon className={classes.mainMenuIcon}>
                        <Person />
                    </ListItemIcon>
                    <ListItemText primary={t('my_profile')} />
                    {open ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItem
                            className={`${classes.nested} ${classes.mainMenuItem}`}
                            button
                            component={NavLink}
                            to="/profile"
                            exact>
                            <ListItemText primary={t('general')} />
                        </ListItem>
                        <ListItem
                            className={`${classes.nested} ${classes.mainMenuItem}`}
                            button
                            component={NavLink}
                            to="/profile/identity"
                            exact>
                            <ListItemText primary={t('identity_doc')} />
                        </ListItem>
                        <ListItem
                            className={`${classes.nested} ${classes.mainMenuItem}`}
                            button
                            component={NavLink}
                            to="/profile/education"
                            exact>
                            <ListItemText primary={t('education')} />
                        </ListItem>
                        {digitalProfileSettings.is_show_section_ege_results
                            ? <ListItem
                                className={`${classes.nested} ${classes.mainMenuItem}`}
                                button
                                component={NavLink}
                                to="/profile/ege-results"
                                exact>
                                <ListItemText primary={t('ege_results')} />
                            </ListItem>
                            : null}
                        {digitalProfileSettings.is_show_section_ege_documents
                            ? <ListItem
                                className={`${classes.nested} ${classes.mainMenuItem}`}
                                button
                                component={NavLink}
                                to="/profile/ege-documents"
                                exact>
                                <ListItemText primary={t('ege_documents')} />
                            </ListItem>
                            : null}
                        <ListItem
                            className={`${classes.nested} ${classes.mainMenuItem}`}
                            button
                            component={NavLink}
                            to="/profile/achievements"
                            exact>
                            <ListItemText primary={t('achievements')} />
                        </ListItem>
                        {digitalProfileSettings.is_show_section_privileges
                            ? <ListItem
                                className={`${classes.nested} ${classes.mainMenuItem}`}
                                button
                                component={NavLink}
                                to="/profile/privileges"
                                exact>
                                <ListItemText primary={t('privileges')} />
                            </ListItem>
                            : null}
                        <ListItem
                            className={`${classes.nested} ${classes.mainMenuItem}`}
                            button
                            component={NavLink}
                            to="/profile/other-documents"
                            exact>
                            <ListItemText primary={t('other_documents')} />
                        </ListItem>
                    </List>
                </Collapse>
                <ListItem className={classes.mainMenuItem} button exact component={NavLink} to="/zajavls">
                    <ListItemIcon className={classes.mainMenuIcon}>
                        <LibraryBooks />
                    </ListItemIcon>
                    <ListItemText primary={t('zajavls')} />
                </ListItem>
                <ListItem className={classes.mainMenuItem} button component={NavLink} exact to="/zajavls/consent-or-refusal">
                    <ListItemIcon className={classes.mainMenuIcon}>
                        <CallSplitIcon />
                    </ListItemIcon>
                    <ListItemText primary={t('consent_or_refusal')} />
                </ListItem>
                <ListItem className={classes.mainMenuItem} button component={NavLink} exact to="/rating_applicants">
                    <ListItemIcon className={classes.mainMenuIcon}>
                        <FormatListNumberedIcon />
                    </ListItemIcon>
                    <ListItemText primary={t('rating_applicants')} />
                </ListItem>
                <ListItem className={classes.mainMenuItem} button component={NavLink} exact to="/profile/settings">
                    <ListItemIcon className={classes.mainMenuIcon}>
                        <SettingsIcon />
                    </ListItemIcon>
                    <ListItemText primary={t('settings')} />
                </ListItem>
                <ListItem className={classes.mainMenuItem} button>
                    <ListItemIcon className={classes.mainMenuIcon}>
                        <Reply />
                    </ListItemIcon>
                    <ListItemText>
                        <Link
                            href={'/abitur'}
                            color="inherit"
                            target="_blank"
                            variant="body1">
                            {t('back_to_site')}
                        </Link>
                    </ListItemText>
                </ListItem>
            </List>
    );
};
export default MainMenu;
